import { z } from 'zod'

export const inputSchema = z.object({
  ['team-slug']: z.string(),
  ['repo-slug']: z.string(),
  token: z.string(),
  ref: z.string(),
})

export const outputSchema = z.object({
  result: z.string(),
})
